/* Rund & Kip: keuze bezorgdag in de winkelwagen
 * Optioneel. Werkdagen (ma t/m vr), maximaal 3 maanden vooruit.
 * Op een werkdag voor 09:00 besteld kan vandaag nog.
 * Sluitingsdagen: alleen de Nederlandse sluitingsdagen van Trunkrs.
 * Bron: support.trunkrs.nl, opgehaald 19 okt 2026. Vul de lijst jaarlijks aan.
 */
(function () {
  var ATTR = 'Gewenste bezorgdag';
  var NOTE_PREFIX = 'Gewenste bezorgdag: ';
  var CUTOFF_HOUR = 9;
  var MONTHS_AHEAD = 3;
  var CLOSED = [
    '2026-12-25', // Eerste Kerstdag
    '2026-12-31', // Oudjaarsdag
    '2027-01-01', // Nieuwjaarsdag
    '2027-03-29', // Tweede Paasdag
    '2027-04-27', // Koningsdag
    '2027-05-06', // Hemelvaartsdag
    '2027-05-17', // Tweede Pinksterdag
    '2027-12-31'  // Oudjaarsdag
  ];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }

  // Huidige datum en uur in Nederland, los van de tijdzone van de bezoeker
  function nowInAmsterdam() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour
    };
  }

  function isDeliveryDay(d) {
    var wd = d.getUTCDay();
    return wd >= 1 && wd <= 5 && CLOSED.indexOf(iso(d)) === -1;
  }

  var dayFmt = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  var shortFmt = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long' });

  function availableDates() {
    var now = nowInAmsterdam();
    var start = new Date(now.date.getTime());
    if (!(isDeliveryDay(start) && now.hour < CUTOFF_HOUR)) start.setUTCDate(start.getUTCDate() + 1);
    var end = new Date(now.date.getTime());
    end.setUTCMonth(end.getUTCMonth() + MONTHS_AHEAD);
    var list = [];
    for (var d = start; d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
      if (isDeliveryDay(d)) {
        var copy = new Date(d.getTime());
        list.push({
          value: dayFmt.format(copy),
          short: shortFmt.format(copy),
          today: iso(copy) === iso(now.date)
        });
      }
    }
    return list;
  }

  function cartUpdate(body) {
    return fetch((window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function setHasDate(has) { document.documentElement.classList.toggle('bzd-has-date', !!has); }

  var uid = 0;

  if (!customElements.get('bezorgdag-picker')) {
    class BezorgdagPicker extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.select = this.querySelector('select');
        this.error = this.querySelector('.bzd-error');
        var id = 'bezorgdag-' + (++uid);
        this.select.id = id;
        this.querySelector('label').setAttribute('for', id);
        var saved = typeof window.__bzdValue === 'string' ? window.__bzdValue : (this.dataset.current || '');
        var dates = availableDates();
        var html = '<option value="">Geen voorkeur</option>';
        var found = false;
        dates.forEach(function (d) {
          var sel = d.value === saved ? ' selected' : '';
          if (sel) found = true;
          var label = (d.today ? 'Vandaag, ' : '') + d.short;
          html += '<option value="' + d.value + '"' + sel + '>' + label + '</option>';
        });
        this.select.innerHTML = html;
        if (saved && !found) {
          // Opgeslagen dag is niet meer mogelijk (bijvoorbeeld voorbij): opnieuw laten kiezen
          cartUpdate({ attributes: { [ATTR]: '' } });
          saved = '';
        }
        window.__bzdValue = saved;
        setHasDate(!!saved);
        this.select.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        var value = this.select.value;
        window.__bzdValue = value;
        if (this.error) this.error.hidden = true;
        setHasDate(!!value);
        document.querySelectorAll('bezorgdag-picker select').forEach(function (s) { s.value = value; });
        cartUpdate({ attributes: { [ATTR]: value } });
      }
    }
    customElements.define('bezorgdag-picker', BezorgdagPicker);
  }

  if (window.__bzdCheckoutGuard) return;
  window.__bzdCheckoutGuard = true;

  // Plaats de kiezer boven elke afrekenknop, ook na het verversen van de winkelwagen-lade
  function mount() {
    var tpl = document.getElementById('bzd-template');
    if (!tpl) return;
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var prev = btn.previousElementSibling;
      if (prev && prev.tagName === 'BEZORGDAG-PICKER') return;
      btn.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), btn);
    });
  }
  var mountTimer;
  function scheduleMount() { clearTimeout(mountTimer); mountTimer = setTimeout(mount, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  new MutationObserver(scheduleMount).observe(document.documentElement, { childList: true, subtree: true });

  // Bij afrekenen: bezorgdag is optioneel. Gekozen dag bovenaan de klantnotitie zetten,
  // geen keuze = geen bezorgdag in notitie en attribuut.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    var picker = btn.previousElementSibling;
    if (!picker || picker.tagName !== 'BEZORGDAG-PICKER') return;
    var select = picker.querySelector('select');
    var value = select.value;
    evt.preventDefault();
    evt.stopPropagation();
    btn.disabled = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var field = document.querySelector('textarea[name="note"]');
        var current = field ? field.value : (cart.note || '');
        var rest = current.replace(/^Gewenste bezorgdag:.*(\r?\n)?/m, '').trim();
        var note = value ? NOTE_PREFIX + value + (rest ? '\n' + rest : '') : rest;
        return cartUpdate({ note: note, attributes: { [ATTR]: value } });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; window.location.href = '/checkout'; });
  }, true);
})();
